export class RegexPatterns {
    static get integersOnly () { return integersOnly };
    static get integersOnlyGTZero () { return integersOnlyGTZero };
    static get decimalsOnly () { return decimalsOnly };
    static get decimalsOnlyGTZero () { return decimalsOnlyGTZero };
    static get lettersOnly () { return lettersOnly };  
    static get alphaNumeric () { return alphaNumeric };  
    static get alphaNumericSpecial () { return alphaNumericSpecial };  
    static get ssn () { return ssn; }
}

const decimalsOnly = /^[0-9]+(\.[0-9]{1,2})|[0-9]?$/;
const decimalsOnlyGTZero = /^[0-9]+(\.[0-9]{1,2})|[0-9]?$/;
const integersOnly = /^[0-9\-]+$/;
const integersOnlyGTZero = /^[1-9][0-9]*$/;
const lettersOnly = /^[a-zA-Z\s]*$/;
const ssn = /^(F|f|NB|nb|T|t|RC|rc)?[0-9\-]+$/;
const alphaNumeric = /^$|^[a-zA-Z0-9\s]+$/;
const alphaNumericSpecial = /^[a-zA-Z0-9\.\,\\\&\/\#\-\'\s]+$/;